import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link ShowSectionMessageCommand}
 */
export type ShowSectionMessageCommandProperties = CommandProperties;

/**
 * Command to show database section messages in the native embed experience.
 *
 * This command displays important system messages, warnings, or informational
 * content related to database operations, ensuring they appear in the host
 * application's flag/message system for better user visibility.
 */
export const ShowSectionMessageCommand = createCommand<
  ShowSectionMessageCommandProperties,
  void
>('show-section-message-command');
